import type { SVGProps } from "react";

const paths = {
  approvals: (
    <>
      <path d="M8 4.5h8M8 8h8M6 2.8h12a2 2 0 0 1 2 2v14.4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4.8a2 2 0 0 1 2-2Z" />
      <path d="m8 15 2.3 2.3L16.5 11" />
    </>
  ),
  audit: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 5 5M8.5 8.5h5M8.5 11.5h4" />
    </>
  ),
  cases: (
    <>
      <path d="M4 6.2A2.2 2.2 0 0 1 6.2 4h3l1.5 2H18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
      <path d="M8 11h8M8 15h5" />
    </>
  ),
  check: <path d="m5 12.5 4.2 4.2L19 7" />,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  controls: (
    <>
      <path d="M4 7h10M18 7h2M4 17h2M10 17h10" />
      <circle cx="16" cy="7" r="2" />
      <circle cx="8" cy="17" r="2" />
    </>
  ),
  download: <path d="M12 3v12m0 0 4-4m-4 4-4-4M4 20h16" />,
  live: (
    <>
      <path d="M4 17V9m5 8V5m5 12v-7m5 7V3" />
      <circle cx="19" cy="3" r="1.2" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="10" width="14" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  plus: <path d="M12 5v14M5 12h14" />,
  refresh: (
    <>
      <path d="M20 7v5h-5" />
      <path d="M18.6 16a8 8 0 1 1 .6-8.6L20 12" />
    </>
  ),
  search: (
    <>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m15.5 15.5 5 5" />
    </>
  ),
  shield: <path d="M12 2.8 20 6v5.8c0 5-3.4 8.2-8 9.7-4.6-1.5-8-4.7-8-9.7V6Zm-3 9.4 2 2 4-4" />,
} as const;

export type IconName = keyof typeof paths;

export function Icon({ name, ...props }: SVGProps<SVGSVGElement> & { name: IconName }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" {...props}>
      {paths[name]}
    </svg>
  );
}

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span
      className={`brand ${compact ? "compact" : ""}`}
      aria-label="GoBro Operations"
      dir="ltr"
      role="img"
    >
      <b>G</b>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="11.4" />
        <path
          d="M21 3.4 3.8 10.6c-.77.32-.72 1.43.08 1.68l6.3 1.97a1 1 0 0 1 .66.66l1.97 6.3c.25.8 1.36.85 1.68.08L21.6 4c.3-.72-.42-1.44-1.14-1.14Z"
          transform="translate(4.4 4.4) scale(.62)"
        />
      </svg>
      <b>Bro</b>
      {!compact && <span>OPS</span>}
    </span>
  );
}
